<template>
  <NxSelectReduced
    :value="localValue"
    :options="listOptions"
    labelText="Tipo Logradouro:"
    id="selectTipoLogradouro"
    placeholder="Selecione o tipo de logradouro"
    :multiple="false"
    @update:value="handleValueUpdate"
    :isDisabled="isDisabled"
  ></NxSelectReduced>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxSelectTipoLogradouro',
  mixins: [useReactiveModelMixin('value')],
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      listOptions: [
        { value: 'AVENIDA', text: 'Avenida' },
        { value: 'BLOCO', text: 'Bloco' },
        { value: 'EST', text: 'Estrada' },
        { value: 'FAZ', text: 'Fazenda' },
        { value: 'JARDIM', text: 'Jardim' },
        { value: 'PRACA', text: 'Praça' },
        { value: 'QUADRA', text: 'Quadra' },
        { value: 'RUA', text: 'Rua' },
        { value: 'RODOVIA', text: 'Rodovia' }
      ],
      selected: null
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectTipoLogradouro.vue